import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Box, Theme, Typography, MenuItem, Badge } from '@mui/material';
import { createStyles, makeStyles, withStyles } from '@mui/styles';
import ShoppingCart from '../../app/Shopping/Components/ShoppingCart';
import ShoppingCartBadge from '../../app/Shopping/Components/ShoppingCartBadge';
import { IState } from '../../state/store.state';
import { isCartOpenSelector, shoppingSessionIdSelector } from '../../app/Shopping/shopping.selectors';
import { logAnalyticsEventAction } from '../../app/Analytics/analytics.actions';
import { EventTypeEnum } from '../../app/Analytics/analytics.enum';
import { navigateAction } from '../layout.actions';
import { getOrderCountWithNoPurchaseOrderSelector } from '../../app/OrderHistory/order.history.selectors';
import { isSuperUserNotImpersonatedSelector } from '../../app/Customer/customer.selectors';
import { notifyWarnAction } from '../../app/Notification/notification.actions';
import paths from './router/paths';

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      right: -12,
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      backgroundColor: theme.palette.error.main,
      padding: '0 2px'
    }
  })
)(Badge);

const HeaderMenu = () => {
  const dispatch = useDispatch();
  const isCartOpen = useSelector((state: IState) => isCartOpenSelector(state));
  const headerClasses = useStyles();

  const sessionId = useSelector((state: IState) => shoppingSessionIdSelector(state));
  const ordersWithoutPoCount = useSelector((state: IState) => getOrderCountWithNoPurchaseOrderSelector(state));
  const isSuperUserNotImpersonated = useSelector((state: IState) => isSuperUserNotImpersonatedSelector(state));

  const linkText = (
    <Box display="flex" alignItems="center" gap={1}>
      <AssignmentOutlinedIcon fontSize="small" />
      <Typography variant="subtitle1">Orders</Typography>
    </Box>
  );

  const dispatchNavigate = (url: string) => {
    dispatch(navigateAction(url));
  };
  const navigate = (url: string) => {
    dispatch(navigateAction(url));
  };
  const handlehomeClick = () => {
    navigate(paths.landing);
  };
  const handleProductNavigation = () => {
    dispatchNavigate(paths.product);
  };
  const handleOrderStatusNavigation = () => {
    if (sessionId !== undefined) {
      dispatch(logAnalyticsEventAction({ sessionId, eventTypeId: EventTypeEnum.ViewOrderHistory }));
    }
    if (isSuperUserNotImpersonated) {
      dispatch(notifyWarnAction('Super Users must impersonate a user to view order history'));
    } else {
      dispatchNavigate(paths.orderHistory);
    }
  };

  return (
    <div className={headerClasses.loggedInContainer}>
      <Box className={headerClasses.HomeButtons}>
        <MenuItem onClick={handlehomeClick}>
          <Box display="flex" alignItems="center" gap={1}>
            <HomeOutlinedIcon fontSize="small" />
            <Typography variant="subtitle1">Home</Typography>
          </Box>
        </MenuItem>
      </Box>
      <Box className={headerClasses.HomeButtons}>
        <MenuItem onClick={handleProductNavigation}>
          <Box display="flex" alignItems="center" gap={1}>
            <Inventory2OutlinedIcon fontSize="small" />
            <Typography variant="subtitle1">Inventory</Typography>
          </Box>
        </MenuItem>
      </Box>
      <Box className={headerClasses.icon} onClick={handleOrderStatusNavigation}>
        {ordersWithoutPoCount > 0 ? (
          <StyledBadge badgeContent={ordersWithoutPoCount} color="secondary" className={headerClasses.icon}>
            {linkText}
          </StyledBadge>
        ) : (
          <Box display="flex">{linkText}</Box>
        )}
      </Box>
      <Box marginRight="50px" className={headerClasses.cart}>
        <>
          <MenuItem>
            <ShoppingCartBadge />
            {isCartOpen ? <ShoppingCart /> : <div />}
          </MenuItem>
        </>
      </Box>
    </div>
  );
};

export default HeaderMenu;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loggedInContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    cart: {
      cursor: 'pointer',
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.palette.warning.main
      }
    },
    HomeButtons: {
      cursor: 'pointer',
      fontWeight: 'bolder',
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.palette.warning.main
      }
    },
    icon: {
      marginRight: '20px',
      cursor: 'pointer',
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.palette.warning.main
      },
      fontWeight: 'bolder'
    }
  })
);
